import { useQuery } from "@tanstack/react-query";
import { adminDashboardService } from "src/services/adminDashboardService";

export const ADMIN_DASHBOARD_STATS_QUERY_KEY = ["admin-dashboard-stats"] as const;

export const useAdminDashboardStats = () =>
  useQuery({
    queryKey: ADMIN_DASHBOARD_STATS_QUERY_KEY,
    queryFn: () => adminDashboardService.fetchStats(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
